import { render, staticRenderFns } from "./ChannelProviderPicker.vue?vue&type=template&id=99b1c864&scoped=true"
import script from "./ChannelProviderPicker.vue?vue&type=script&lang=js"
export * from "./ChannelProviderPicker.vue?vue&type=script&lang=js"
import style0 from "./ChannelProviderPicker.vue?vue&type=style&index=0&id=99b1c864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b1c864",
  null
  
)

export default component.exports